module.exports = {"230715001":"红星街道","230715400":"清水河经营所","230715401":"五星河经营所","230715402":"汤洪岭林场","230715403":"汤北林场","230715404":"霍吉河林场","230715405":"二杨经营所","230715406":"三杨林场","230715407":"汤南林场","230715408":"共青经营所","230715409":"库斯特林场","230715410":"二皮河经营所"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230715.json
// module id = 696
// module chunks = 0